module.exports = __webpack_public_path__ + "img/cyber-security.9755aa44.svg";